module.exports = __webpack_public_path__ + "img/logo_homecredit.10efff04.png";